export const CutsceneOverlay = ({ caption, onSkip }) => (
  <div className="absolute inset-0 z-20 pointer-events-none" data-testid="cutscene-overlay">
    <button className="pointer-events-auto absolute top-[7%] right-3 pixel-text text-base sm:text-lg text-[#64748B] hover:text-[#F3F4F6] transition-colors"
      onClick={onSkip} data-testid="cutscene-skip-button">[E] skip ▸▸</button>
    {caption && (
      <p key={caption} className="absolute bottom-[12%] left-0 right-0 text-center px-4 pixel-text text-lg sm:text-3xl text-[#E5E7EB] rise"
        style={{ textShadow: "2px 2px 0 #000" }} data-testid="cutscene-caption">{caption}</p>
    )}
  </div>
);
